import type { Id } from '@/convex/_generated/dataModel';

export const PROJECTS_PAGE_SIZE = 3;
export const PROJECT_THREADS_PAGE_SIZE = 4;
/**
 * Chats per project in the server-rendered sidebar: one page plus a lookahead
 * row, so "Show more" renders server-side too.
 */
export const PROJECT_THREADS_PREVIEW_LIMIT = PROJECT_THREADS_PAGE_SIZE + 1;
export const PROJECT_ORGANIZER_PAGE_SIZE = 20;
export const MAX_PINNED_CHATS = 10;

/** Args of the small first-paint project chat list (server seed + client). */
export function projectThreadsPreviewArgs(
  orgSlug: string,
  folderId: Id<'threadFolders'>
) {
  return { orgSlug, folderId, limit: PROJECT_THREADS_PREVIEW_LIMIT };
}
